import { firebaseConfig } from './config'
import { initializeApp } from 'firebase/app'

const app = initializeApp(firebaseConfig)
const secondaryApp = initializeApp(firebaseConfig, 'Secondary')

export { app, secondaryApp }
